(() => {
  'use strict';

  const PRODUCT_ID = '15457901576324';
  const PRODUCT_KEY = 'staylift';
  const SCOPE = '[data-afz-staylift-reviews-scope]';
  const CARD = '[data-source-review-card][data-source-review-id]';

  function sourceUrl(row) {
    const value = row.source_review_url || row.source_url;
    if (typeof value !== 'string' || !value) return null;
    try {
      const url = new URL(value);
      if (url.protocol !== 'https:') return null;
      const sourceProduct = ['luckmeey.com', 'www.luckmeey.com'].includes(url.hostname)
        && url.pathname.replace(/\/$/, '') === '/products/staylift-strapless-bra';
      const sourceReviewSite = ['judge.me', 'app.judge.me'].includes(url.hostname)
        && url.pathname.replace(/\/$/, '') === '/reviews/stores/luckmeey.com/products/staylift-strapless-bra';
      return sourceProduct || sourceReviewSite ? url.href : null;
    } catch (_) {
      return null;
    }
  }

  function bind(wrapper) {
    if (wrapper.dataset.productKey !== PRODUCT_KEY || wrapper.dataset.productId !== PRODUCT_ID) return;
    if (wrapper.dataset.afzStayliftReviewMetaBound === 'true') return;
    const instance = wrapper.querySelector('afz-source-reviews');
    const dataNode = instance?.querySelector('[data-source-review-data]');
    if (!instance || !dataNode) return;

    let data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (_) {
      return;
    }
    if (data.display_version !== 2 || !Array.isArray(data.reviews)) return;
    const rows = new Map(data.reviews.map(row => [String(row.source_review_id || ''), row]));
    wrapper.dataset.afzStayliftReviewMetaBound = 'true';

    function decorate(card) {
      if (card.closest('afz-source-reviews') !== instance) return;
      if (card.querySelector('[data-afz-staylift-review-meta]')) return;
      const row = rows.get(card.dataset.sourceReviewId);
      if (!row || ![4, 5].includes(row.rating)) return;
      const url = sourceUrl(row);
      const meta = document.createElement('p');
      meta.className = 'afz-staylift-review-source-meta';
      meta.dataset.afzStayliftReviewMeta = 'true';

      if (row.source_verified_claim === true) {
        const verified = document.createElement('span');
        verified.textContent = 'Verified by source';
        verified.dataset.afzStayliftSourceVerified = 'true';
        meta.append(verified);
      }
      if (row.is_incentivized === true) {
        const incentive = document.createElement('span');
        incentive.textContent = 'Incentivized review at source';
        incentive.dataset.afzStayliftSourceIncentive = 'true';
        meta.append(incentive);
      }
      if (url) {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = 'View source';
        link.dataset.afzStayliftSourceLink = 'true';
        meta.append(link);
      }
      if (!meta.childElementCount) return;
      const author = card.querySelector('.afz-buyer-show__author');
      if (author) author.insertAdjacentElement('afterend', meta);
      else card.append(meta);
    }

    instance.querySelectorAll(CARD).forEach(decorate);
    const observer = new MutationObserver(records => {
      const addedCards = new Set();
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches(CARD)) addedCards.add(node);
          node.querySelectorAll(CARD).forEach(card => addedCards.add(card));
        }
      }
      addedCards.forEach(decorate);
    });
    observer.observe(instance, { childList: true, subtree: true });
  }

  function initialize(root = document) {
    if (root.nodeType === 1 && root.matches(SCOPE)) bind(root);
    root.querySelectorAll?.(SCOPE).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
